(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    $('.menu-item-has-children a').on("click", function () {
      console.log('Accordion');
      $(this).next().toggleClass('accordion-friend--active');
      $(this).toggleClass('accordion--active');
    });
  });
})(window, document, jQuery);
"use strict";

function getTop() {
  return jQuery(window).scrollTop();
}

function isIE11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function scroll_to(element, distance = 10) {
  const $element = jQuery(element);
  const $site_navbar = jQuery('#site_navbar');

  if ($element.length) {
    const scrollTop = $element.first().offset().top - ($site_navbar.outerHeight() + window.parseInt(distance));
    jQuery('html, body').animate({
      scrollTop
    }, {
      duration: 1000,
      easing: 'easeInOutExpo'
    });
  }
}

class Comp_Factory {
  constructor($, CLASS_NAME) {
    this.$ = $;
    this.CLASS_NAME = CLASS_NAME;
  }

  open() {
    return this.$.addClass(this.CLASS_NAME);
  }

  close() {
    return this.$.removeClass(this.CLASS_NAME);
  }

  toggle() {
    return this.$.toggleClass(this.CLASS_NAME);
  }

  is_open() {
    return this.$.hasClass(this.CLASS_NAME);
  }

}

;

(function (window, document, $) {
  $.fn.doSlickSlide = function (direction) {
    var self = $(this),
        slickSection = self.closest('.slick-section');
    if (slickSection.length > 0) slickSection.find('.slick-slider').slick(direction);
    return this;
  };

  $('.slick-next').on('click', function () {
    $(this).doSlickSlide('slickNext');
  });
  $('.slick-prev').on('click', function () {
    $(this).doSlickSlide('slickPrev');
  });
  $.easing['jswing'] = $.easing['swing'];
  $.extend(jQuery.easing, {
    easeInOutExpo: function (x, t, b, c, d) {
      if (t == 0) return b;
      if (t == d) return b + c;
      if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
      return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
    }
  });
})(window, document, jQuery);
let map;

function initMap() {
  // Create styled map
  const styledMapType = new google.maps.StyledMapType([{
    "elementType": "geometry",
    "stylers": [{
      "color": "#1d2c4d"
    }]
  }, {
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#8ec3b9"
    }]
  }, {
    "elementType": "labels.text.stroke",
    "stylers": [{
      "color": "#1a3646"
    }]
  }, {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#4b6878"
    }]
  }, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#64779e"
    }]
  }, {
    "featureType": "administrative.province",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#4b6878"
    }]
  }, {
    "featureType": "landscape.man_made",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#334e87"
    }]
  }, {
    "featureType": "landscape.natural",
    "elementType": "geometry",
    "stylers": [{
      "color": "#023e58"
    }]
  }, {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [{
      "color": "#283d6a"
    }]
  }, {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#6f9ba5"
    }]
  }, {
    "featureType": "poi",
    "elementType": "labels.text.stroke",
    "stylers": [{
      "color": "#1d2c4d"
    }]
  }, {
    "featureType": "poi.park",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#023e58"
    }]
  }, {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#3C7680"
    }]
  }, {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [{
      "color": "#304a7d"
    }]
  }, {
    "featureType": "road",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#98a5be"
    }]
  }, {
    "featureType": "road",
    "elementType": "labels.text.stroke",
    "stylers": [{
      "color": "#1d2c4d"
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [{
      "color": "#2c6675"
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [{
      "color": "#255763"
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#b0d5ce"
    }]
  }, {
    "featureType": "road.highway",
    "elementType": "labels.text.stroke",
    "stylers": [{
      "color": "#023e58"
    }]
  }, {
    "featureType": "transit",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#98a5be"
    }]
  }, {
    "featureType": "transit",
    "elementType": "labels.text.stroke",
    "stylers": [{
      "color": "#1d2c4d"
    }]
  }, {
    "featureType": "transit.line",
    "elementType": "geometry.fill",
    "stylers": [{
      "color": "#283d6a"
    }]
  }, {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [{
      "color": "#3a4762"
    }]
  }, {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [{
      "color": "#0e1626"
    }]
  }, {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [{
      "color": "#4e6d70"
    }]
  }], {
    name: "Aubergine"
  }); // Create a map object, and include the MapTypeId to add
  // to the map type control.

  const map = new google.maps.Map(document.getElementById("map"), {
    center: {
      lat: 32.07704000349474,
      lng: 34.78589541331372
    },
    zoom: 17,
    mapTypeControlOptions: {
      mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "styled_map"]
    }
  }); //Associate the styled map with the MapTypeId and set it to display.

  map.mapTypes.set("styled_map", styledMapType);
  map.setMapTypeId("styled_map");
}

(function (window, document, $) {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {});
})(window, document, jQuery);
(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    const menuTrigger = $(".menuTrigger");
    const hamburger = $(".header__navigator");
    let activatedMenu = false; // Display menu

    menuTrigger.on("click", function () {
      if (!activatedMenu) {
        $(".header + .dropdown").slideDown(400, function () {
          window.dispatchEvent(new Event('resize'));
          screen.width < 992 && $("body").addClass('body--menu');
        });
        activatedMenu = true;
        changeMenuImage(hamburger);
      } else {
        $(".header + .dropdown").fadeOut('slow', function () {
          screen.width < 992 && $("body").removeClass('body--menu');
        });
        activatedMenu = false;
        changeMenuImage(hamburger);
      }

      $(".header__navigator .menu-text").toggleClass('active');
    });

    function changeMenuImage(element) {
      $('.header__navigator .header__navigator--image').toggleClass('none'); // Lines animation

      $(element).toggleClass('active');
      $(element).toggleClass('not-active');
    } // Click on exit menu


    $('.dropdown__exit').on('click', function () {
      $(".header + .dropdown").fadeOut('slow', function () {
        $("body").removeClass('body--menu');
      });
      activatedMenu = false;
      changeMenuImage(hamburger);
    }); // Capabilities

    $('.menu-item-has-children > a').addClass('accordion');
    $('.menu-item-has-children > .sub-menu').addClass('accordion-friend');
  });
})(window, document, jQuery);
(function (window, document, $) {
  $(document).ready(function ($) {
    // scroll down
    $("#scrollDownHome").on("click", function () {
      $('html, body').animate({
        scrollTop: $('.home-about').offset().top
      }, 800);
    }); // Switch between Practices and Industries

    let capability = '#practices';
    $(capability).toggleClass('capabilities--active');
    $(".home-capabilities__title").on('click', function () {
      if (capability != this.dataset.capability) {
        $('.home-capabilities__title').toggleClass('active');
        capability = this.dataset.capability;
        $('.capabilities').toggleClass('capabilities--active');
      }
    }); // In home page: Display the regular header after scrolling

    let headerActivated = false;
    isHomePage() && $(window).on('scroll', function () {
      if (!headerActivated && $(document).scrollTop() > 750) {
        $('.header').removeClass('header-home slideInDownHome').addClass('regular-header slideInDown');
        headerActivated = true;
      } else if (headerActivated && $(document).scrollTop() < 750) {
        $('.header').removeClass('regular-header slideInDown').addClass('header-home slideInDownHome');
        headerActivated = false;
      }
    });
  });

  function isHomePage() {
    return window.location.pathname == '' || window.location.pathname == '/';
  }
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";
})(window, document, jQuery);
(function (window, document, $) {
  $(document).ready(function ($) {
    console.log(window.location.hostname); // lottie

    var animation = bodymovin.loadAnimation({
      container: document.getElementById('lottie'),
      // Required
      path: '/wp-content/themes/horn-co/assets/json/main/data_new.json',
      // Required
      renderer: 'svg',
      // Required
      loop: true,
      // Optional
      autoplay: true // Optional

    });
  });
})(window, document, jQuery);
;

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    const $modal_member = $('.modal--member');
    let videoId = ''; // 	Occurs when the modal is about to be shown

    $modal_member.on('  &:hover {\n' + '    background-image: linear-gradient(to left, lighten($color-gradiant-start, 10%), lighten($color-gradiant-end, 10%));\n' + '  }', function () {
      const id = $(this).attr('id');
      const $toggle = $(`[href="#${id}"]`);
      $toggle.addClass('js-open');
    }); // Occurs when the modal is about to be hidden

    $modal_member.on('hide.bs.modal', function () {
      const id = $(this).attr('id');
      const $toggle = $(`[href="#${id}"]`);
      $toggle.removeClass('js-open');
    }); // Open modal

    $('.open-modal').on('click', function (e) {
      console.log('open sesame');
      e.preventDefault();
      $('.modal').show();
      $("#modal-activator").addClass('active-modal');
      $('.modal__exit-button')[0].focus();
    }); // exit modal

    $('.modal__exit-button').on('click', () => exitModal());

    function exitModal() {
      console.log('close sesame');
      $('.modal').hide();
      $("#modal-activator").removeClass('active-modal');
    }

    $(".modal").on('show.bs.modal', function () {
      // inject id
      const iframe = this.querySelector('iframe');
      iframe.src = `https://www.youtube.com/embed/${videoId}`;
    });
    $(".modal").on('hide.bs.modal', function () {
      console.log(this);
      const iframe = this.querySelector('iframe');
      iframe.src = ``;
    });
  });
})(window, document, jQuery);

(function (window, document, $) {
  "use strict";

  $(document).ready(function ($) {
    var mySwiper = new Swiper('.home-slider', {
      speed: 500,
      autoplay: {
        delay: 4000
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
    var mySwiper_masthead = new Swiper('.home-masthead-slider', {
      speed: 2500,
      autoplay: {
        delay: 1000
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    });
    var mySwiper2 = new Swiper('.members-slider', {
      speed: 500,
      loop: true,
      slidesPerView: 1.5,
      spaceBetween: 5.8,
      breakpoints: {
        768: {
          slidesPerView: 3
        },
        992: {
          spaceBetween: 14,
          slidesPerView: 5
        }
      },
      navigation: {
        nextEl: '.members-next',
        prevEl: '.members-prev'
      }
    });
    var mySwiper3 = new Swiper('.news-slider', {
      speed: 500,
      loop: true,
      spaceBetween: 0,
      // 
      slidesPerColumnFill: 'row',
      slidesPerView: 1,
      slidesPerColumn: 2,
      breakpoints: {
        992: {
          spaceBetween: 10,
          slidesPerView: 2,
          slidesPerColumn: 1
        }
      },
      navigation: {
        nextEl: '.news-next',
        prevEl: '.news-prev'
      }
    });
    var mySwiper4 = new Swiper('.about-slider', {
      speed: 500,
      loop: true,
      spaceBetween: 0,
      autoplay: {
        delay: 4000
      },
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerColumnFill: 'row',
      resizeEvent: 'auto',
      disableAutoResize: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      }
    });
  });
})(window, document, jQuery);